module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vrepr19-05affba3d6330d5ae3040253f246d11d.jpg";